import { Button, Text } from "@radix-ui/themes";
import { DisplayMoney } from "../../components/display-money";
import { CheckoutResponse } from "../../api/hitl-api";
import { AppBasedPayment } from "../../components/app-based-payment";
import { TerminalPayment } from "../../components/terminal-payment";
import { useTranslation } from "react-i18next";

export function Sidebar({
  data,
  isCompleted,
  isEditable,
  cartsCount,
  onFinishEditing,
  onCancelEditing,
}: {
  data: CheckoutResponse["result"] | null;
  isCompleted: boolean;
  isEditable: boolean;
  cartsCount: number;
  onFinishEditing?: () => void;
  onCancelEditing?: () => void;
}) {
  const total = data;
  const linesCount = data?.lines.length;
  const { t } = useTranslation();

  return (
    <>
      <aside className="min-w-[300px] w-[300px] h-full">
        <div className="flex flex-col h-full gap-3">
          <div className="p-4 flex-grow bg-white border border-card-border rounded-2xl">
            <Text as="p" size="5" mb="4" weight="bold" color="gray" highContrast>
              {t("paymentDetails")}
            </Text>
            <table className="w-full">
              <tbody>
                <tr className="border-b border-card-border">
                  <td className="py-2">
                    <Text size="3" color="gray" highContrast>
                      {t("customerCarts")}
                    </Text>
                  </td>
                  <td className="py-2">
                    <Text as="p" align="right" size="3" color="gray" highContrast>
                      {cartsCount}
                    </Text>
                  </td>
                </tr>
                <tr className="border-b border-card-border">
                  <td className="py-2">
                    <Text size="3" color="gray" highContrast>
                      {t("items")}
                    </Text>
                  </td>
                  <td className="py-2">
                    <Text as="p" align="right" size="3" color="gray" highContrast>
                      {linesCount}
                    </Text>
                  </td>
                </tr>
                <tr>
                  <td className="py-2" rowSpan={2}>
                    <Text size="3" mb="2" as="p" color="gray" highContrast>
                      {t("subtotal")}
                    </Text>
                    <Text size="3" as="p" color="gray" highContrast>
                      {t("estimatedTax")}
                    </Text>
                  </td>
                  <td className="py-2" rowSpan={2}>
                    <Text as="p" mb="2" align="right" color="gray" highContrast>
                      <DisplayMoney value={total?.price_before_tax} />
                    </Text>
                    <Text as="p" align="right" color="gray" highContrast>
                      <DisplayMoney value={total?.tax_price} />
                    </Text>
                  </td>
                </tr>
                <tr></tr>
                <tr>
                  <td>
                    <Text as="p" weight="bold" mt="2" size="5" color="gray" highContrast>
                      {t("total")}
                    </Text>
                  </td>
                  <td>
                    <Text as="p" align="right" mt="2" size="5" weight="bold" color="gray" highContrast>
                      <DisplayMoney value={total?.price_with_tax} />
                    </Text>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div className="p-4 flex flex-col gap-2 bg-white border border-card-border rounded-2xl">
            {isEditable ? (
              <>
                <Button variant="classic" size="4" onClick={onFinishEditing}>
                  {t("finishEditing")}
                </Button>
                <Button variant="outline" size="4" onClick={onCancelEditing}>
                  {t("cancelEditing")}
                </Button>
              </>
            ) : (
              <>
                <AppBasedPayment isCompleted={isCompleted} />
                <TerminalPayment isCompleted={isCompleted} lines={data?.lines} />
              </>
            )}
          </div>
        </div>
      </aside>
    </>
  );
}
